import React from "react";
import Navbar from "../Components/Navigation/Navbar";
import {Button, Card, Row} from "react-bootstrap";
import Impressum from "../Components/contact/impressum";
import ContactForm from "../Components/contact/form";
import '../Components/contact/contact.css';
import DSGVO from "../Components/contact/dsgvo";

export function ImpressumPage() {
    return (<>
            <Navbar/>
            <Card>
                <Card.Header>Impressum</Card.Header>
                <Impressum></Impressum>
                <DSGVO></DSGVO>
            </Card>

            <Card className="impressum">
                <Button variant="Link" href="/impressum">Impressum</Button>
            </Card>
        </>


    )

}

export default ImpressumPage;